import React from 'react';
// material-ui
import { Avatar, Button, Grid, Stack, TextField, Typography } from '@mui/material';

// project imports
import useAuth from 'hooks/useAuth';
import SubCard from 'ui-component/cards/SubCard';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { gridSpacing } from 'store/constant';
import { useDispatch } from 'store';
// assets
import { MenuItem, Select } from '@mui/material';

// third-party
import { useFormik } from 'formik';
import * as yup from 'yup';
import { openSnackbar } from 'store/slices/snackbar';

// ==============================|| PROFILE 3 - PROFILE ||============================== //

const validationSchema = yup.object({
    displayName: yup.string().required('Vui lòng điền tên'),
    business_name: yup.string().required('Vui lòng điền tên Doanh nghiệp / Tổ chức'),
    phone_number: yup.string().required('Vui lòng điền Số điện thoại liên hệ')
});
const languages = [
    {
        value: 'vi',
        label: 'Tiếng Việt'
    },
    {
        value: 'en',
        label: 'English'
    },
    {
        value: 'ko',
        label: 'Tiếng Hàn'
    }
];
const Profile = () => {
    const [language, setLanguage] = React.useState('vi');
    const [education_or_enterprise, setEducationOrCompany] = React.useState('enterprise');
    const { user, userUpdate } = useAuth();
    const dispatch = useDispatch();
    const formik = useFormik({
        initialValues: {
            displayName: user?.['user']['displayName'],
            business_name: user?.['user']['business_name'],
            phone_number: user?.['user']['phone_number'],
            email: user?.['user']['email'],
            uid: user?.['id'],
            education_or_enterprise
        },
        validationSchema,
        onSubmit: (props) => {
            userUpdate(props.uid, props.displayName, props.email, props.business_name, props.phone_number, education_or_enterprise);
            dispatch(
                openSnackbar({
                    open: true,
                    message: 'Cập nhật thành công',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    },
                    close: false
                })
            );
        }
    });

    return (
        <Grid container spacing={gridSpacing}>
            <Grid item sm={6} md={4}>
                <SubCard title="Ảnh đại diện" contentSX={{ textAlign: 'center' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Avatar alt="User 1" src={user?.['user']['photo_url']} sx={{ width: 100, height: 100, margin: '0 auto' }} />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="center">
                                Tải lên/Thay đổi ảnh đại diện
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <AnimateButton>
                                <Button
                                    variant="contained"
                                    style={{ color: 'white', borderColor: '#1976D2', backgroundColor: '#1976D2' }}
                                    size="small"
                                >
                                    Tải lên ảnh đại diện
                                </Button>
                            </AnimateButton>
                        </Grid>
                    </Grid>
                </SubCard>
            </Grid>
            <Grid item sm={6} md={8}>
                <SubCard title="Thông tin cá nhân">
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container spacing={gridSpacing}>
                            <Grid item xs={12}>
                                <TextField
                                    id="outlined-basic1"
                                    fullWidth
                                    label="Họ và tên"
                                    // defaultValue={user?.['user']['displayName']}
                                    name="displayName"
                                    value={formik.values.displayName}
                                    onChange={formik.handleChange}
                                    error={formik.touched.displayName && Boolean(formik.errors.displayName)}
                                    helperText={formik.touched.displayName && formik.errors.displayName}
                                />
                            </Grid>
                            {/* <Grid item xs={12}>
                                <TextField id="outlined-basic6"
                                    fullWidth
                                    label="Email address"
                                    disabled
                                    value={formik.values.email}
                                />
                            </Grid> */}
                            <Grid item>
                                <Select value={language} onChange={(e) => setLanguage(e.target.value)}>
                                    {languages.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                            {/* <Grid item md={6} xs={12}>
                            <TextField id="outlined-basic4" 
                            fullWidth 
                            label="Tên tổ chức"                             
                            name="business_name"
                            value={formik.values.business_name}
                            onChange={formik.handleChange}
                            error={formik.touched.business_name && Boolean(formik.errors.business_name)}
                            helperText={formik.touched.business_name && formik.errors.business_name}
                            />
                        </Grid>                         */}
                            {/* <Grid item md={6} xs={12}>
                            <TextField id="outlined-basic7" 
                            fullWidth
                            label="Số điện thoại" 
                            name="phone_number"
                            value={formik.values.phone_number}
                            onChange={formik.handleChange}
                            error={formik.touched.phone_number && Boolean(formik.errors.phone_number)}
                            helperText={formik.touched.phone_number && formik.errors.phone_number}
                            />
                        </Grid> */}
                            {/* <Grid item>
                            <FormControl>
                                <RadioGroup
                                    row
                                    aria-label="business_name"
                                    value={education_or_enterprise}
                                    onChange={(e) => setEducationOrCompany(e.target.value)}
                                    name="row-radio-buttons-group"
                                >
                                    <FormControlLabel value="enterprise" control={<Radio />} label="Doanh nghiệp" />
                                    <FormControlLabel value="education" control={<Radio />} label="Tổ chức giáo dục" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>                     */}

                            <Grid item xs={12}>
                                <Stack direction="row">
                                    <AnimateButton>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            style={{ color: 'white', borderColor: '#1976D2', backgroundColor: '#1976D2' }}
                                        >
                                            Cập nhật thông tin
                                        </Button>
                                    </AnimateButton>
                                </Stack>
                            </Grid>
                        </Grid>
                    </form>
                </SubCard>
            </Grid>
        </Grid>
    );
};

export default Profile;
